import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Calendar, AlertTriangle } from "lucide-react";
import Seo from "@/components/Seo";
import { fetchGuides } from "@/lib/api";

export default function Blog() {
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    fetchGuides().then(setGuides).catch(() => {});
  }, []);

  return (
    <>
      <Seo title="Guides - Gaming Phone Guides for Pakistan" description="Authority guides on buying used-kit and box-pack gaming phones in Pakistan: inspection checklists, chipset comparisons and market explainers." path="/guides" />

      <div className="border-b border-border bg-graphite">
        <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-cyber/30 bg-cyber/10 px-3 py-1 text-xs font-heading font-semibold text-cyber"><BookOpen className="h-3.5 w-3.5" /> Authority Content</span>
          <h1 className="mt-4 font-display text-2xl font-black tracking-tight text-white sm:text-4xl">Guides</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-300 sm:text-base">Practical, region-aware guides on buying gaming phones in Pakistan - condition, chipsets, PTA and market realities.</p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {guides.map((g) => (
            <Link key={g.slug} data-testid={`guide-card-${g.slug}`} to={`/guides/${g.slug}`} className="group flex flex-col overflow-hidden rounded-xl border border-border bg-slateSurface transition-all hover:-translate-y-1 hover:border-cyber/50">
              <div className="aspect-[16/9] overflow-hidden bg-graphite">
                <img src={g.cover_image} alt={g.title} loading="lazy" className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap gap-1.5">
                  {(g.tags || []).map((t) => <span key={t} className="rounded-md border border-border bg-graphite px-2 py-0.5 text-[10px] font-medium text-slate-400">{t}</span>)}
                  {g.risk_disclaimer && <span className="inline-flex items-center gap-1 rounded-md border border-amberw/30 bg-amberw/10 px-2 py-0.5 text-[10px] font-medium text-amberw"><AlertTriangle className="h-3 w-3" /> Advisory</span>}
                </div>
                <h2 className="mt-3 font-heading text-base font-bold text-white group-hover:text-cyber">{g.title}</h2>
                <p className="mt-1 line-clamp-2 flex-1 text-xs text-slate-400">{g.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-slate-500">
                  <span className="flex items-center gap-1"><Calendar className="h-3 w-3" /> {g.updated_date}</span>
                  <span className="flex items-center gap-1"><BookOpen className="h-3 w-3" /> {g.read_minutes} min</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
